import React from 'react';
import { AlertTriangle } from 'lucide-react';
import { useMaintenanceCheck } from '../../hooks/useMaintenanceCheck';

function formatCountdown(totalSeconds: number): string {
    const minutes = Math.floor(totalSeconds / 60);
    const seconds = totalSeconds % 60;
    return `${minutes}:${seconds.toString().padStart(2, '0')}`;
}

export const MaintenanceBanner: React.FC = () => {
    const { status, secondsRemaining } = useMaintenanceCheck();

    if (!status?.isScheduled) return null;

    const isActive = secondsRemaining !== null && secondsRemaining <= 0;

    return (
        <div
            className={`fixed top-0 left-0 right-0 z-[55] px-4 py-2.5 flex items-center justify-center gap-3 shadow-md ${
                isActive
                    ? 'bg-red-600 text-white'
                    : 'bg-amber-500 text-white'
            }`}
        >
            <AlertTriangle size={18} className="flex-shrink-0" />
            <span className="text-sm font-medium">
                {isActive ? (
                    'Systemvedlikehold pågår. Lagre arbeid og vent.'
                ) : (
                    <>
                        Systemet stenges for vedlikehold om{' '}
                        <span className="font-bold tabular-nums">
                            {formatCountdown(secondsRemaining!)}
                        </span>
                    </>
                )}
                {status.message && (
                    <span className="ml-2 opacity-90">— {status.message}</span>
                )}
            </span>
        </div>
    );
};
